export const getDefinedDate = (
  date1?: string | Date,
  date2?: string | Date
) => {
  if (date1) {
    if (typeof date1 === "string") {
      return new Date(date1);
    }
    return date1;
  }
  if (date2) {
    if (typeof date2 === "string") {
      return new Date(date2);
    }
    return date2;
  }
  return undefined;
};
